import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    PublishPage as PublishPageMutation,
    PublishPageVariables as PublishPageMutationVariables,
} from 'nutshell-graphql-types';

import PUBLISH_PAGE from '../mutations/publish-page.graphql';

export function usePublishPage(): {
    publishPage: (pageVersionId: string) => Promise<any>;
    isPublishing: boolean;
    error: string | null | undefined;
} {
    const [publishPage, {loading, error}] = useMutation<
        PublishPageMutation,
        PublishPageMutationVariables
    >(PUBLISH_PAGE);

    return {
        publishPage: (pageVersionId: string) =>
            publishPage({
                variables: {input: {pageVersionId}},
            }),
        isPublishing: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
